module.exports = __webpack_public_path__ + "img/sop0.19454f75.jpg";